<div class="pl-pane__container--horizontal pl-pane--full-screen">

  <div class="pl-pane__container--horizontal pl-pane--full-screen">
    @if (orgSiteDomain) {
      <app-ngin-iframe
        [path]="surveyResultUrl"
        [domain]="orgSiteDomain">
      </app-ngin-iframe>
    }
  </div>

</div>
